import { useEffect, useState } from 'react';
import api from '../api/api';

/**
 * useAdSenseConfig - AdSense 設定をグローバル取得・キャッシュするフック
 *
 * 管理画面（/admin/affiliate）で設定された clientId/slotId/adFormat/showForPlans を
 * public エンドポイントから1回だけ取得し、モジュールレベルでキャッシュする。
 *
 * 戻り値: { enabled, clientId, slotId, adFormat, showForPlans, locations } | null
 */

let cachedConfig = null;
let pendingPromise = null;
const subscribers = new Set();

const fetchConfig = () => {
  if (pendingPromise) return pendingPromise;
  pendingPromise = api.get('/api/affiliate/widget-config')
    .then(res => {
      if (res?.data?.success) {
        cachedConfig = res.data.config?.adsense || null;
        subscribers.forEach(cb => cb(cachedConfig));
      }
    })
    .catch(err => {
      console.warn('AdSense config 取得エラー:', err?.message || err);
    })
    .finally(() => {
      pendingPromise = null;
    });
  return pendingPromise;
};

export const useAdSenseConfig = () => {
  const [config, setConfig] = useState(cachedConfig);

  useEffect(() => {
    if (cachedConfig !== null) {
      setConfig(cachedConfig);
      return;
    }
    subscribers.add(setConfig);
    fetchConfig();
    return () => {
      subscribers.delete(setConfig);
    };
  }, []);

  return config;
};
